export var SpinnerSize;
(function (SpinnerSize) {
    SpinnerSize["xs"] = "xs";
    SpinnerSize["s"] = "s";
    SpinnerSize["m"] = "m";
    SpinnerSize["l"] = "l";
    SpinnerSize["xl"] = "xl";
})(SpinnerSize || (SpinnerSize = {}));
